module.exports = {
  tHome: 'Trang chủ',
  tRelatedPosts: 'Bài liên quan',
  tTags: 'Tags',
  tTransationAvailable: 'Dịch bài: ',
  taIndKeywords: [`blogging`, `swift`, `javascript`, `react`, `gatsby`, `ios`],
};
